/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectFormatSearchKey { 
    /**
     * The namespace
     */
    namespace: string;
    /**
     * The name of the business object definition
     */
    businessObjectDefinitionName?: string;
    /**
     * The filter for business object formats that explicitly designated to classify all business object data registered under them as                   \"records\"                
     */
    filterOnRecords?: boolean;
    /**
     * The filter for business object formats that explicitly designated to classify all business object data registered under them as                   \"non-records\"                
     */
    filterOnNonRecords?: boolean;
    /**
     * The record reference code
     */
    recordCode?: string;
}
